import React from "react";

const EntriesSelector = ({ entriesPerPage, setEntriesPerPage, setCurrentPage }) => {
  return (
    <div className="d-flex align-items-center">
      <label className="me-2 fw-semibold">Show</label>
      <select
        className="form-select form-select-sm"
        style={{
          width: "120px",
          height: "38px",
          borderRadius: "6px",
          borderColor: "#ced4da",
          fontSize: "14px",
        }}
        value={entriesPerPage}
        onChange={(e) => {
          setEntriesPerPage(Number(e.target.value));
          setCurrentPage(1);
        }}
      >
        <option value={10}>10</option>
        <option value={50}>50</option>
        <option value={100}>100</option>
        
      </select>
      <label className="ms-2 fw-semibold">entries</label>
    </div>
  );
};

export default EntriesSelector;
